// import { ContentfulAsset, ContentfulPageConnection, ContentfulTile, ContentfulTileDescriptionTextNode } from '../types/graphql-types'
import { SideNav } from '../types/navigation.types'

export default function getContentfulTileStructure(
  contentfulPageConnection: { nodes: ReadonlyArray<GatsbyTypes.sideNavFragment> },
  sideNavs: SideNav[],
): GatsbyTypes.tileFragment[] {
  const groupDescriptionMap: Record<string, string> = {}
  const thumbnailMap: Record<
    string,
    GatsbyTypes.Maybe<{ readonly file: GatsbyTypes.Maybe<Pick<GatsbyTypes.ContentfulAssetFile, 'url'>> }>
  > = {}
  contentfulPageConnection.nodes.forEach(page => {
    if (page.group?.id && page.group?.description) {
      groupDescriptionMap[page.group?.id] = page.group?.description
    }
    if (page.group?.id && page.group?.thumbnail) {
      thumbnailMap[page.group?.id] = page.group?.thumbnail
    }
  })
  return sideNavs
    .filter(sideNav => sideNav.title)
    .map(sideNav => {
      const tileFragment: GatsbyTypes.tileFragment = {
        id: sideNav.id,
        title: sideNav.title,
        navigationLink: sideNav.links[0].url,
        image: {
          file: thumbnailMap[sideNav.id]?.file,
          title: sideNav.title,
        },
        description: {
          description: groupDescriptionMap[sideNav.id],
        },
        imageFit: undefined,
        downloadLink: undefined,
        variant: 'Standard-Vertical',
        __typename: 'ContentfulTile',
      }
      return tileFragment
    })
}
